export default "__VITE_ASSET__CVqABPGv__"